var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6405 11.4992L8.7074 5.86561L8.027 5.13281L1.027 11.6328L0.6324 11.9992L1.027 12.3656L8.027 18.8656L8.7074 18.1328L2.6405 12.4992H23.3672V11.4992H2.6405Z",
    fill: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/arrow_large_inverse.c073afc1.svg";
export { SvgComponent as ReactComponent };